import { DOC_PATH } from "./GlobalConstant";
import { DocumentationType } from "../../middleware/Constants/DocumentationConstant";

export { DOC_PATH, DocumentationType }

export const MdFileExtension = ".md";
export const HtmlFileExtension = ".html";
export const XmlFileExtension = ".xml";
export const YmlFileExtension = ".yml";
export const JsonFileExtension = ".json";
export const fileExtensionsList = [MdFileExtension, HtmlFileExtension, XmlFileExtension, ".xls", ".doc", ".txt", ".pdf", YmlFileExtension, JsonFileExtension, ".jpg", ".png", ".exe"];
export const DocumentationTitle = "Documentation";
export const IosDocumentationGettingStartedUrl = "/doc/sdk/ios/lts/guides/Getting_Started"

export const DocumentationSdkPath = "/doc/sdk";
export const DocumentationLtsFile = "documentation_lts.yml";
export const DocumentationStsFile = "documentation_sts.yml";
export const DocumentationVersionFile = "version" + JsonFileExtension;

export const DocumentationBetaTagName = "isBeta";
